module.exports = __webpack_public_path__ + "static/media/explore-icon.d73501ab.svg";